<template>
    <v-dialog v-model="showDialog" max-width="600px" persistent scrollable>
      <v-card>
        <v-card-title class="bg-gray-light">
          <span class="text-h5 label-black">{{ title }}</span>
          <v-btn @click.prevent="handleConfirmCloseModal" class="ml-auto" icon>
            <v-icon id="close-button">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container class="pt-0 pb-0">
              <div class="row m-1">
                <div class="col-xl-12 col-lg-12 col-12">
                  <div class="input-group input-group-sm">
                    <h6 class="input-group-addon mb-1 label-black">{{ $t("apiKey.apiKeyName") }}&nbsp;</h6>
                  </div>
                  <div class="input-group-append">
                    <div class="row">
                      <div class="col-xl-12 col-lg-12 col-12">
                        <div class="row">
                          <div class="col-xl-12 col-lg-12 col-12">
                            <v-text-field type="text"
                                v-model="apiKeyName" hide-details="auto" outlined dense
                                maxLength = "255"
                                :rules="requiredRule(apiKeyName, 'apiKey.apiKeyName')"
                                >
                            </v-text-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="text-white mr-1" style="background-color: #3d76ad" text
                 @click="handleAddApiKey(event)">
            {{ $t("labels.systemUserManager.save") }}
          </v-btn>
          <v-btn class="bg-secondary text-white" text @click.prevent="handleConfirmCloseModal">
            {{ $t("commonPopup.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64" style="color: #3d76ad !important;"></v-progress-circular>
      </v-overlay>
    </v-dialog>
  </template>
  
  <script>
  import { EventBus } from '@/utils/eventBus.js'
  import { mapActions } from 'vuex';
  import {
    getCookieSiteUser, setCurrentPageCode
  } from "@/utils/auth";
  import $ from 'jquery';
  import { ResponseCode } from "@/constants/constants"
  
  export default {
      name: "AddApiKeyModal",
      props: ['visible', 'titleModal', 'frameId', 'session'],
      data() {
          return {
              valid: false,
              loading: false,
              title: "",
              showDialog: false,
              PAGE_CODE: 'SA_CSM',
              requiredRule(value, label) {
                const errorMsg = [this.$t(label) + this.ERROR_CODES['IS_REQUIRED']];
                if ((!value && value !== 0) || value?.toString()?.trim().length === 0) {
                  return errorMsg
                } else {
                  return [];
                }
              },
              apiKeyName: null,
              siteId: null
          }
      },
      computed: {
      },
    created() {
          setCurrentPageCode(this.PAGE_CODE);
          EventBus.$on('handleOpenAddApiKeyModal', (value) => {
            this.siteId = value.siteId;
            this.title = value.title;
            this.showDialog = value.flag;
          });
      },
      watch: {
          "$i18n.locale": async function () {
              this.getErrorCode("site");
          },
          // 'showDialog'(val) {
          //   if (val) {
          //     this.generateShareLink();
          //   }
          // }
      },
      async beforeMount() {
          // import ERROR_CODES by language
          this.getErrorCode("site");
      },
      methods: {
          ...mapActions("sites", {
            getApiKeyList: "getApiKeyList",
            createApiKey: "createApiKey"
          }),
          handleConfirmCloseModal() {
            this.commonConfirmVue(this.ERROR_CODES['CF_052_01_01'], () => {
              this.apiKeyName = null;
              this.$refs.form?.resetValidation();
              this.showDialog = false;
            });
          },
          handleAddApiKey() {
              this.$refs.form.validate()
              if (!this.$refs.form.validate()) {
                  return;
              }
              var request = {
                  siteId: this.siteId,
                  apiKeyName: this.apiKeyName
              }
              this.createApiKey(request)
                  .then(response => {
                      if (response.code === 0) {
                          this.loading = false;
                          this.showDialog = false;
                          this.commonNotifyVue(this.ERROR_CODES['SAVE_OK'], 'success');
                          this.apiKeyName = null;
                          this.$refs.form?.resetValidation();
                          this.$emit('handleGetListApiKey', this.siteId);
                      } else {
                          this.loading = false;
                          this.commonNotifyVue(this.ERROR_CODES[response.code], 'warning');
                      }
                  })
                  .catch(err => {
                      this.loading = false;
                      console.log(err);
                      if(err.code != undefined)
                        this.commonNotifyVue(this.ERROR_CODES[err.code], 'warning');
                  })
                  .finally(final => {
                      this.loading = false;
                      this.isSubmitAction = false;
                  });
  
          },
      }
  }
  </script>
  
  <style lang="scss" scoped>
  .width-150{
    width: 150px !important;
  }
  
  .sign {
    margin-top: 3px;
  }
  .setting-export-checkBox {
      margin-right: 50px !important
    }
  .v-card__actions {
      border-top: 1px solid #ebebeb;
  }
  
  .label-black {
      color: black !important;
  }
  
  .checkboxLabel {
      margin-top: 8px !important;
      font-weight: 100;
      color: black;
  }
  .radioLabel {
      margin-top: 8px !important;
      font-weight: 100;
      color: black;
  }
  
  
  ::v-deep{
    .v-dialog {
      box-shadow: none !important;
    }
    .v-card {
      margin-top: 2rem !important;
    }
    @media only screen and (min-width:768px) {
      .sign {
        margin-left: 2px !important;
      }
    }
    @media only screen and (max-width: 500px) and (max-height: 1000px) and (orientation: portrait){
    .v-card {
      margin-top: 5rem !important;
    }
    .setting-export-checkBox {
      margin-right: 0px !important
    }
    .v-dialog > .v-card > .v-card__text {
      padding: 0 0 0 0 !important;
    }
  }
    @media (min-width: 768px) and (max-width: 1366px) and (orientation: portrait) {
      .v.card {
        margin-top: 4em !important
      }
    }
  }
  </style>
  